// @flow
import { put, call, takeLatest } from "redux-saga/effects";
import {
  GET_PROGRESS_REQUEST,
  GET_PROGRESS_REQUEST_SUCCESS,
  GET_PROGRESS_REQUEST_ERROR,
} from "../constants";
import axios from "../../../services/api";

function* getProgressRequest(data) {
  const params = new URLSearchParams();
  params.append("induction_id", data.induction_id);
  try {
    const response = yield call(axios.get, "/progress/", { params });
    if (response.data.error) {
      yield put({
        type: GET_PROGRESS_REQUEST_ERROR,
        data: response.error,
      });
    } else {
      yield put({
        type: GET_PROGRESS_REQUEST_SUCCESS,
        data: response.data,
      });
    }
  } catch (error) {
    yield put({
      type: GET_PROGRESS_REQUEST_ERROR,
      data: error,
    });
  }
}

export default function* getProgressRequestSaga() {
  yield takeLatest(GET_PROGRESS_REQUEST, getProgressRequest);
}
